import React from 'react';
import { HelpCircle } from 'lucide-react';
import Tooltip from '../ui/Tooltip';

/**
 * InfoHint — a small, unobtrusive help icon that surfaces a one-line hint on hover / focus / tap. Used across the
 * Studio controls to guide first-timers without cluttering the UI. Uses the shared Tooltip (reliable + styled +
 * touch-friendly), NOT the native `title` attribute (which is slow and invisible on touch). Monochrome; keyboard-focusable.
 */
const InfoHint: React.FC<{ text: string }> = ({ text }) => (
  <Tooltip content={text}>
    <span
      aria-label={text}
      tabIndex={0}
      className="inline-flex cursor-help align-middle text-secondary-300 hover:text-secondary-500 focus:text-secondary-500 dark:text-secondary-600 dark:hover:text-secondary-400"
    >
      <HelpCircle className="h-3 w-3" />
    </span>
  </Tooltip>
);

export default InfoHint;
